import { AppRolePermissions } from '../../permissions'

const BUSINESS_ADMIN: AppRolePermissions = {
  active_assortment_view: true,
  assortment_backups_create: true,
  assortment_backups_restore: true,
  assortment_banners_edit: true,
  assortment_banners_publish: true,
  assortment_banners_view: true,
  assortment_launches_create: true,
  assortment_launches_edit: true,
  assortment_launches_publish: true,
  assortment_launches_view: true,
  assortment_materials_clean_up: true,
  assortment_materials_replace: true,
  assortment_materials_sequences_edit: true,
  assortment_materials_sync: true,
  audit_trails_view: true,
  customers_banners_view: false,
  customers_stores_view: true,
  invites_delete: false,
  invites_send: false,
  invites_view: false,
  map_viewAllAreas: true,
  materials_bcp_priced_view: true,
  materials_materials_list_view: true,
  materials_price_list_view: true,
  operations_execute: false,
  orders_all_view: true,
  orders_charts_view: true,
  orders_editQuantities: true,
  orders_flagged_view: true,
  orders_leg_release_timeout_edit: true,
  orders_payment_review_release: true,
  orders_payment_review_view: true,
  orders_uncouple: true,
  orders_release: true,
  orders_returns_view: true,
  reports_view: true,
  reports_view_ecc: true,
  reports_view_material: true,
  reports_view_misc: true,
  reports_view_operations: true,
  reports_view_order_service: true,
  reports_view_salesforce: true,
  roles_view: false,
  sox_compliance_scheduled_reports_create: false,
  sox_compliance_scheduled_reports_delete: false,
  sox_compliance_scheduled_reports_edit: false,
  sox_compliance_view: false,
  upload_allUploads_view: true,
  upload_autoDistro: true,
  upload_autoInject: true,
  upload_autoInjectDeliveryDates: true,
  upload_autoInjectRMA: true,
  upload_ediPOConfControl: true,
  upload_erpSkuSubstitution: true,
  upload_limitQuantity: true,
  upload_limitQuantityExemptions: true,
  upload_materialSpecificationConversion: true,
  upload_merchandise: true,
  upload_myUpload_view: true,
  upload_nodAddPosition: true,
  upload_onHandInventoryDuns: true,
  upload_onHandInventoryPartial: true,
  upload_onHandInventoryUOM: true,
  upload_routeStopSequence: true,
  upload_skuUpcOverride: true,
  upload_suspendOrderSubmission: true,
  upload_taxRate: true,
  users_manageAdmins: false,
  users_managePermissionsOverrides: false,
  users_manageAccess: false,
  users_manageTerritoriesOverrides: true,
  users_view: true,
}

export default BUSINESS_ADMIN
